import { Controller } from "@hotwired/stimulus"

// Un campo del modulo della domanda (Campo di components/readiness/ModuloDomanda.js): lo stato di React del componente
// (v, motivo, na) per readiness/app_prep/_campo.
// - «Non applicabile…» apre il modulo del motivo (target `na`, `apri` nascosto), «Annulla» lo chiude; «Salva» (target
//   `salva`) si attiva con almeno 3 caratteri del motivo, tolti gli spazi ai lati.
// - Il valore (target `valore`: il riquadro della proposta dell'AI o il campo da scrivere) attiva «Conferma»/«Salva»
//   (target `conferma`) solo se non è vuoto; il riquadro ha Math.min(14, Math.max(3, ceil(lunghezza / 90) + a capo))
//   righe, ricalcolate a ogni carattere.
// Morph (CONVENZIONI «Modifiche non salvate e morph»): React tiene v, motivo e na finché il componente resta montato,
// anche dopo il salvataggio (onUpdate riscrive solo i dati). Qui i tre valori sono sull'elemento e il morph non li
// riscrive (turbo:before-morph-attribute); finito il morph dell'elemento (turbo:morph-element) si rimettono sui target,
// anche quelli nuovi. Un campo tolto e rimesso parte da capo, come un componente rimontato.
// «Campi del modulo» chiuso (toggle-box:chiuso della scheda che contiene il campo): React smontava Campo ({open && …}),
// quindi v torna c.valore (il valore del server, defaultValue del target), motivo vuoto e il modulo del motivo chiuso.
export default class extends Controller {
  static targets = ["valore", "conferma", "apri", "na", "motivo", "salva"]
  static values = { aperto: Boolean, valore: String, motivo: String }
  static TENUTI = ["data-campo-na-aperto-value", "data-campo-na-valore-value", "data-campo-na-motivo-value"]

  connect() {
    this.trattieni = (event) => {
      if (event.target === this.element && this.constructor.TENUTI.includes(event.detail.attributeName)) event.preventDefault()
    }
    this.riapplica = (event) => { if (event.target === this.element) this.mostra() }
    this.element.addEventListener("turbo:before-morph-attribute", this.trattieni)
    this.element.addEventListener("turbo:morph-element", this.riapplica)
    this.mostra()
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-attribute", this.trattieni)
    this.element.removeEventListener("turbo:morph-element", this.riapplica)
  }

  apri() { this.apertoValue = true }

  azzera(event) {
    if (!event.target.contains(this.element)) return
    if (this.hasValoreTarget) this.valoreValue = this.valoreTarget.defaultValue
    this.motivoValue = ""
    this.apertoValue = false
    this.mostra()
  }

  chiudi() { this.apertoValue = false }

  scrivi(event) {
    if (this.hasValoreTarget && event.target === this.valoreTarget) this.valoreValue = event.target.value
    if (this.hasMotivoTarget && event.target === this.motivoTarget) this.motivoValue = event.target.value
    this.controlla()
  }

  apertoValueChanged() { this.mostra() }

  // i valori di React sui target (anche quelli riscritti da un morph) e lo stato dei pulsanti
  mostra() {
    if (this.hasValoreTarget && this.valoreTarget.value !== this.valoreValue) this.valoreTarget.value = this.valoreValue
    if (this.hasMotivoTarget && this.motivoTarget.value !== this.motivoValue) this.motivoTarget.value = this.motivoValue
    this.naTargets.forEach((el) => el.toggleAttribute("hidden", !this.apertoValue))
    this.apriTargets.forEach((el) => el.toggleAttribute("hidden", this.apertoValue))
    this.controlla()
  }

  controlla() {
    const v = this.valoreValue
    if (this.hasConfermaTarget) this.confermaTarget.disabled = !v.trim()
    if (this.hasSalvaTarget) this.salvaTarget.disabled = this.motivoValue.trim().length < 3
    if (this.hasValoreTarget && this.valoreTarget.tagName === "TEXTAREA") {
      this.valoreTarget.rows = Math.min(14, Math.max(3, Math.ceil(v.length / 90) + (v.match(/\n/g) || []).length))
    }
  }

  valoreTargetConnected() { this.mostra() }
  motivoTargetConnected() { this.mostra() }
}
